import React, {useEffect, useRef, useState} from "react";
import {
    GoogleMap,
    Marker,
    Polyline,
    GroundOverlay,
    withGoogleMap,
    withScriptjs,
} from "react-google-maps";

// Red Marker (Default): http://maps.google.com/mapfiles/ms/icons/red-dot.png
// Blue Marker: http://maps.google.com/mapfiles/ms/icons/blue-dot.png
// Green Marker: http://maps.google.com/mapfiles/ms/icons/green-dot.png
// Yellow Marker: http://maps.google.com/mapfiles/ms/icons/yellow-dot.png
// Purple Marker: http://maps.google.com/mapfiles/ms/icons/purple-dot.png
// Light Blue Marker: http://maps.google.com/mapfiles/ms/icons/ltblue-dot.png
// Orange Marker: http://maps.google.com/mapfiles/ms/icons/orange-dot.png

const CustomMap = withScriptjs(
    withGoogleMap((props) => {
        const { markers, setMarkers, mapOptions, onMarkerDragEnd, onMapClick, onMarkerClick, onZoomChange, markerOptions, onMarkerOptionClick } = props;
        const mapRef = useRef(null);

        // useEffect(() => {
        //     // Aquí podrías agregar lógica adicional si es necesario
        //     console.log("Markers updated:", markers);
        // }, [markers]);
        //
        // useEffect(() => {
        //     console.log("Marker options updated:", markerOptions);
        // }, [markerOptions])

        const handleMarkerDragEnd = (event, index) => {
            const updatedMarkers = [...markers];
            updatedMarkers[index] = {
                ...updatedMarkers[index],
                lat: event.latLng.lat(),
                lng: event.latLng.lng(),
            };
            setMarkers(updatedMarkers); // Actualiza el estado de los markers
            //onMarkerDragEnd(event, index); // Llama a la función de callback proporcionada
        };

        const handleZoomChanged = () => {
            if (mapRef.current) {
                const zoomLevel = mapRef.current.getZoom();
                onZoomChange(zoomLevel); // Llama al callback con el nivel de zoom actual
            }
        };

        return (
            <GoogleMap
                ref={mapRef}
                defaultZoom={mapOptions?.zoom || 15}
                maxZoom={mapOptions?.maxZoom || 40}
                minZoom={mapOptions?.minZoom || 2}
                defaultCenter={mapOptions?.center || { lat: 20.588953, lng: -87.114580 }}
                mapTypeId={mapOptions?.mapType || "satellite"}
                onClick={onMapClick}
                onZoomChanged={handleZoomChanged}
            >
                {/* Dibujar la línea */}
                {markers.length > 1 && (
                    <Polyline
                        path={markers}
                        options={{
                            strokeColor: "#FF0000",
                            strokeOpacity: 0.8,
                            strokeWeight: 3,
                        }}
                    />
                )}

                {/* Mostrar los markers */}
                {markers.map((marker, index) => (
                    <Marker
                        key={index}
                        position={{ lat: marker.lat, lng: marker.lng }}
                        draggable={true}
                        onDragEnd={(event) => handleMarkerDragEnd(event, index)}
                        onClick={() => onMarkerClick(marker, index)}
                        icon={
                            marker.isSelected
                                ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                                : undefined
                        }
                    />
                ))}

                {/* Mostrar los markers */}
                {markerOptions.map((marker, index) => (
                    <Marker
                        key={index}
                        position={{ lat: marker.lat, lng: marker.lng }}
                        draggable={false}
                        onClick={() => onMarkerOptionClick(marker, index)}
                        icon={"http://maps.google.com/mapfiles/ms/icons/orange-dot.png"}
                    />
                ))}

                {/* Mostrar el overlay */}
                {mapOptions?.overlayImage && (
                    <GroundOverlay
                        defaultUrl={mapOptions.overlayImage}
                        bounds={mapOptions.overlayBounds}
                    />
                )}
            </GoogleMap>
        );
    })
);

const MapControllerV2 = ({ markers, mapOptions, onMarkerDragEnd, onMapClick, setMarkers, onMarkerClick, onZoomChange, markerOptions, onMarkerOptionClick }) => {
    return (
        <CustomMap
            googleMapURL={"https://maps.googleapis.com/maps/api/js?key=AIzaSyCk3DIMp9YWIAPf1QRjv9zVRVyjJZ2t0Gw&v=3.exp&libraries=geometry,drawing,places"}
            loadingElement={<div style={{ height: "100%" }} />}
            containerElement={<div style={{ height: "100%" }} />}
            mapElement={<div style={{ height: "100%" }} />}
            markers={markers}
            setMarkers={setMarkers}
            mapOptions={mapOptions}

            onMarkerDragEnd={onMarkerDragEnd}
            onMapClick={onMapClick}
            onMarkerClick={onMarkerClick}

            markerOptions={markerOptions}
            onMarkerOptionClick={onMarkerOptionClick}

            onZoomChange={onZoomChange}
        />
    );
};

export default MapControllerV2;